import { useEffect, useState } from "react";
import TransactionServices from "../TransactionServices";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function Matching_Song(param: any) {

    let [isGen, setisGen] = useState(true);
    let [trackTitle, setTrackTitle] = useState("");
    let [trackArtist, setTrackArtist] = useState("");
    let [accountCode, setaccountCode] = useState("");
    let [Search_field, setSearch_field] = useState("");
    let [isrcOrCatNum, setRsrcOrCatNum] = useState("");
    let [searchError, setSearchError] = useState(false);
    let [filter_search, setfilter_search] = useState("");
    let [filterFormats, setFilterFormats] = useState("");
    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [tab_number, setTab_Number] = useState("Track_Song");
    let [MatchingSongCount, setMatchingSongCount] = useState(0);
    let [UnmatchedCount, setUnmatchedCount] = useState<any>([]);
    let [Search_field_type, setSearch_field_type] = useState("");
    let [repItemCodeSold, setRepItemCodeSoldrackTitle] = useState("");
    let [MatchingSongSearch, setMatchingSongSearch] = useState<any>([]);
    let [selectMatchingAsset, setSelectMatchingAsset] = useState<any>([]);
    let [matchingSongViewAll, setMatchingSongViewAll] = useState<any>([]);
    let [filteredUnmatchedData, setfilteredUnmatchedData] = useState<any>([]);
    let [matchingSongViewAllCount, setMatchingSongViewAllCount] = useState(0);
    let [MatchingSongSearchTemp, setMatchingSongSearchTemp] = useState<any>([]);
    let [selectcatalogUnMatched, setSelectCatalogUnMatched] = useState<any>([]);
    let [factSalesRawAccountCode, setFactSalesRawAccountCode] = useState<any>([]);

    var MatchingSongPagination = { pageNumber: 1, pageSize: 10 }
    var MatchingSongViewAllPagination = { pageNumber: 1, pageSize: 10 }

    useEffect(() => {
        api_call();
    }, []);

    const api_call = () => {
        TransactionServices.matchingCalatog({}).then((respond: any) => setFactSalesRawAccountCode(respond))
    }

    const matchingSongViewAllPagination = (e: any) => {
        MatchingSongViewAllPagination.pageNumber = e.pageNumber;
        MatchingSongViewAllPagination.pageSize = e.pageSize;

        matchingCalatog(Search_field, Search_field_type)
    }

    const matchingCalatog = (e: any, type: any) => {
        Search_field = e
        setSearch_field(Search_field);

        Search_field_type = type;
        setSearch_field_type(Search_field_type);

        var payload = {
            accountCode: type == "View All" ? "" : accountCode, ourCode: '',
            pageNumber: 1, pageSize: 10, search: Search_field
        }

        TransactionServices.getRelAliases(payload).then((res: any) => {
            matchingSongViewAll = res
            setMatchingSongViewAll(matchingSongViewAll)
            matchingSongViewAllCount = res[0]?.totalRows ?? 0
            setMatchingSongViewAllCount(matchingSongViewAllCount)
        })
    }

    const onChangeAccountCode = (e: any) => {
        accountCode = e;
        setaccountCode(accountCode)

        var payload = { pageNumber: 1, pageSize: 10, sortBy: "unMtchValue", sortOrder: "ASC", search: filter_search }
        if (accountCode.length > 0) {
            TransactionServices.getUnmatchedSong(accountCode, payload).then((respond: any) => {
                filteredUnmatchedData = respond
                setfilteredUnmatchedData(filteredUnmatchedData)
                UnmatchedCount = respond[0]?.totalRows ?? 0
                setUnmatchedCount(UnmatchedCount)
            })
        } else {
            filteredUnmatchedData = []
            setfilteredUnmatchedData(filteredUnmatchedData)
            UnmatchedCount = 0
            setUnmatchedCount(UnmatchedCount)
        }

    }

    const matchingSongsExport = () => { TransactionServices.getUnmatchedSongExport(accountCode, {}) }

    const onMatchSongsRefresh = () => {
        filter_search = ''
        setfilter_search(filter_search)
        onChangeAccountCode(accountCode)
    }

    const setSearchCat = () => {
        trackTitle = ''
        setTrackTitle(trackTitle)

        trackArtist = ''
        setTrackArtist(trackArtist)

        isrcOrCatNum = ''
        setRsrcOrCatNum(isrcOrCatNum)

        repItemCodeSold = ''
        setRepItemCodeSoldrackTitle(repItemCodeSold)
    }

    const loadSystemSongs = () => {
        var payload = { trackArtist: trackArtist, titleTrack: trackTitle, isrcSong: isrcOrCatNum, repItemCodeSold: repItemCodeSold }

        if (trackArtist.length == 0 && trackTitle.length == 0 && isrcOrCatNum.length == 0 && repItemCodeSold.length == 0) {
            searchError = true
            setSearchError(searchError)

            setTimeout(function () {
                searchError = false
                setSearchError(searchError)
            }, 3000);
            return;
        }

        if (tab_number == "Releases") {
            TransactionServices.releaseMatchingCatalogueSearch(payload).then((respond: any) => {
                MatchingSongSearchTemp = respond?.compilation
                setMatchingSongSearchTemp(MatchingSongSearchTemp)

                MatchingSongSearch = respond?.compilation?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, (MatchingSongPagination.pageSize * MatchingSongPagination.pageNumber))
                setMatchingSongSearch(MatchingSongSearch)

                MatchingSongCount = respond?.compilation?.length ?? 0
                setMatchingSongCount(MatchingSongCount)
            })
        }

        if (tab_number == "Track_Song") {
            TransactionServices.trackMatchingCatalogueSearch(payload).then((respond: any) => {
                MatchingSongSearchTemp = respond?.track
                setMatchingSongSearchTemp(MatchingSongSearchTemp)

                MatchingSongSearch = respond?.track?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, (MatchingSongPagination.pageSize * MatchingSongPagination.pageNumber))
                setMatchingSongSearch(MatchingSongSearch)

                MatchingSongCount = respond?.track?.length ?? 0
                setMatchingSongCount(MatchingSongCount)
            })
        }

        if (tab_number == "Contract") {
            TransactionServices.contractMatchingCatalogueSearch(payload).then((respond: any) => {
                MatchingSongSearchTemp = respond?.contract
                setMatchingSongSearchTemp(MatchingSongSearchTemp)

                MatchingSongSearch = respond?.contract?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, (MatchingSongPagination.pageSize * MatchingSongPagination.pageNumber))
                setMatchingSongSearch(MatchingSongSearch)

                MatchingSongCount = respond?.contract?.length ?? 0
                setMatchingSongCount(MatchingSongCount)
            })
        }

        if (tab_number == "Class_List") {
            TransactionServices.classListMatchingCatalogueSearch(payload).then((respond: any) => {
                MatchingSongSearchTemp = respond?.classList
                setMatchingSongSearchTemp(MatchingSongSearchTemp)

                MatchingSongSearch = respond?.classList?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, (MatchingSongPagination.pageSize * MatchingSongPagination.pageNumber))
                setMatchingSongSearch(MatchingSongSearch)

                MatchingSongCount = respond?.classList?.length ?? 0
                setMatchingSongCount(MatchingSongCount)
            })
        }
    }

    const MatchingSong_PaginationChange = (paginationEvent: any) => {
        MatchingSongPagination.pageNumber = paginationEvent.pageNumber;
        MatchingSongPagination.pageSize = paginationEvent.pageSize;

        MatchingSongSearch = MatchingSongSearchTemp?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, (MatchingSongPagination.pageSize * MatchingSongPagination.pageNumber))
        setMatchingSongSearch(MatchingSongSearch)
    }

    const selectRadioCatalog = (e: any) => {
        selectcatalogUnMatched = e;
        setSelectCatalogUnMatched(selectcatalogUnMatched);

        trackTitle = e?.trackTitle ? e?.trackTitle : e?.albumTitle ? e?.albumTitle : "";
        setTrackTitle(trackTitle)

        trackArtist = e?.trackArtist ? e?.trackTitle : e?.albumArtist ? e?.albumTitle : "";
        setTrackArtist(trackArtist)

        isrcOrCatNum = e?.itemCodeSold ? e?.itemCodeSold : "";
        setRsrcOrCatNum(isrcOrCatNum)

        repItemCodeSold = ""
        setRepItemCodeSoldrackTitle(repItemCodeSold)

        loadSystemSongs();
        matchingCalatog(e?.repItemCodeSold, "Search")
    }

    const Select_MatchingAsset = (e: any) => {
        selectMatchingAsset = e;
        setSelectMatchingAsset(selectMatchingAsset);
    }

    const saveSongsLink = () => {
        console.log("saveCataloguesLink")
        console.log(selectcatalogUnMatched)
        console.log(selectMatchingAsset)

        if (!selectcatalogUnMatched?.repItemCodeSold) {
            CommonUtilities.showToastDawer("Rep Item Code Sold is Empty", "fail");
            return;
        }

        if (!selectcatalogUnMatched?.uniqueId && !selectMatchingAsset?.intStdRecCode) {
            CommonUtilities.showToastDawer("You need to select at least one catalog and one system catalog to match", "fail");
            return;
        }

        var merge_payload = {
            catLogNumber: null, format: null, releaseTitle: null, artistName: null, intStdRecCode: null, trackTitle: null, isrcArtistName: null, repItemCodeSold: null
        }

        var save_payload = { ...selectcatalogUnMatched, ...merge_payload }

        if (tab_number == "Track_Song") {
            save_payload.intStdRecCode = selectMatchingAsset.intStdRecCode;
        }

        console.log(save_payload)
        var payload = { accountCode: isGen ? "GEN" : accountCode, ourCode: "", search: merge_payload?.repItemCodeSold }
        TransactionServices.getRelAliasesCount(payload).then((respond: any) => {

            if (respond > 0) {
                CommonUtilities.showToastDawer("The Rep Item Code Sol has already been aliased ", "fail");
            } else {
                TransactionServices.saveRelAliases(accountCode, isGen, { unmatchedCatalogue: save_payload }).then((respond: any) => {
                    CommonUtilities.showToastDawer("Catalogs have been matched successfully", "Success");
                })
            }
        })
    }

    const filter_Formats = (e: any) => {

        console.log(e)
        console.log(tab_number)

        filterFormats = e
        setFilterFormats(filterFormats)
        let filteredData: [] = [];

        if (tab_number == "Releases") {
            filteredData = !e ? MatchingSongSearchTemp : MatchingSongSearchTemp?.filter((fat: any) =>
                fat.catLogNumber?.toLowerCase()?.includes(e.toLowerCase()) || fat.barcodeNum?.toLowerCase()?.includes(e.toLowerCase()) ||
                fat.artistName?.toLowerCase()?.includes(e.toLowerCase()) || fat.title?.toLowerCase()?.includes(e.toLowerCase()) ||
                fat.format?.toLowerCase()?.includes(e.toLowerCase()) || fat.label?.toLowerCase()?.includes(e.toLowerCase())
            );
        }

        if (tab_number == "Track_Song") {
            filteredData = !e ? MatchingSongSearchTemp : MatchingSongSearchTemp?.filter((fat: any) =>
                fat.intStdRecCode?.toLowerCase()?.includes(e.toLowerCase()) || fat.isrcArtistName?.toLowerCase()?.includes(e.toLowerCase()) ||
                fat.trackTitle?.toLowerCase()?.includes(e.toLowerCase()) || fat.trackTitle?.toLowerCase()?.includes(e.toLowerCase())
            );
        }

        if (tab_number == "Contract") {
            filteredData = !e ? MatchingSongSearchTemp : MatchingSongSearchTemp?.filter((fat: any) =>
                fat.contractArtist?.toLowerCase()?.includes(e.toLowerCase()) || fat.contractRefNum?.toLowerCase()?.includes(e.toLowerCase()) ||
                fat.contractTitle?.toLowerCase()?.includes(e.toLowerCase()) || fat.kontactDisplay?.toLowerCase()?.includes(e.toLowerCase())
            );
        }

        if (tab_number == "Class_List") {
            filteredData = !e ? MatchingSongSearchTemp : MatchingSongSearchTemp?.filter((fat: any) => fat.releaseISRC?.toLowerCase()?.includes(e.toLowerCase()) || fat.classList?.toLowerCase()?.includes(e.toLowerCase()));
        }

        MatchingSongSearch = filteredData?.slice((MatchingSongPagination.pageNumber - 1) * MatchingSongPagination.pageSize, MatchingSongPagination.pageNumber * MatchingSongPagination.pageSize);
        setMatchingSongSearch(MatchingSongSearch)
    }

    const tab_change = (e: any) => {
        tab_number = e
        setTab_Number(tab_number)
        loadSystemSongs();
    }

    const deleteCAlias = (e: any) => {
        deleteData = e;
        setDeleteData(deleteData);

        deleteStatus = true;
        setDeleteStatus(deleteData);
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            TransactionServices.deleteRelAliasesPub(deleteData?.relAliId).then(() => {
                matchingCalatog(Search_field, Search_field_type);
                CommonUtilities.showToastDawer("Alias deleted successfully", 'Success');
            })
        }

        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    return (
        <>
            <div className="ws-12 allowHscroll allowVscroll">

                <div className="ws-12 box mbl borderRounded">

                    <h2 className="mt mll">Matching Songs</h2>

                    <div className="box-content">
                        {false && <div className="alert alert-info">Operation queued for processing</div>}
                        {false && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}
                        {false && <div className="alert alert-info m0 mb">No Song found for the selected account code or matching your search criteria </div>}

                        <div className="form-format ws-6">
                            <label >Account Code*</label>
                            <div className="label-entries">
                                <select title="Choose Account Code" onChange={(e: any) => onChangeAccountCode(e.target.value)} id="accountCode" value={accountCode} name="accountCode" required>
                                    <option value="" >Choose Account Code</option>
                                    {
                                        factSalesRawAccountCode?.map((values: any) => {
                                            return (
                                                <option value={values?.code} label={values?.name}>{values?.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        {accountCode.length > 0 && <div className="form-format ws-6" >

                            <div className="ws-12 mb">
                                <label className="control-label ws-12">Search</label>
                                <div className="ws-8">
                                    <input type="text" className="input-sm m0 ws-12 " placeholder="Search unmatched Songs" value={filter_search} onChange={(e: any) => setfilter_search(e.target.value)} id="catLog" />
                                </div>

                                <div className="ws-4">
                                    <button className="btn icon-btn edit" onClick={() => onChangeAccountCode(accountCode)}> <i className="icon-search"></i>  </button>
                                </div>
                            </div>

                        </div>}

                        {accountCode.length == 0 && <div className="alert alert-info m0">Select an account code </div>}
                        {UnmatchedCount > 0 && <h4 className="ws-12">{UnmatchedCount} record(s) found </h4>}

                        <div className="ws-12  allowHscroll allowVscroll">

                            {UnmatchedCount > 0 && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th className="forceSingleLine">Rep item code sold</th>
                                        <th className="forceSingleLine">
                                            <div className="width120">
                                                Album Title
                                                <span ng-click="sortByValueOrder = true; sortBy = 'albumTitle'; onMatchSongsRefresh();">  <i className="icon-sort-up pull-right text-xl"></i></span>
                                                <span ng-click="sortByValueOrder = false; sortBy = 'albumTitle'; onMatchSongsRefresh();">  <i className="icon-sort-down pull-right text-xl"></i></span>

                                            </div>
                                        </th>
                                        <th className="forceSingleLine">Album Artist</th>
                                        <th className="forceSingleLine">Track(s)/Song(s) Title </th>
                                        <th className="forceSingleLine">Track(s)/Song(s) Artist</th>
                                        <th className="forceSingleLine">Album code 1</th>
                                        <th className="forceSingleLine">Album code 2</th>
                                        <th className="forceSingleLine">Track(s)/Song(s) code 1</th>
                                        <th className="forceSingleLine">Track(s)/Song(s) code 2</th>
                                        <th className="forceSingleLine">Subformat</th>
                                        <th className="forceSingleLine">Item code sold</th>
                                        <th className="forceSingleLine">
                                            <div className="width150">
                                                Unmatched value
                                                <span ng-click="sortByValueOrder = true; sortBy = 'unMtchValue'; onMatchSongsRefresh();"> <i className="icon-sort-up text-xl pull-right"></i></span>
                                                <span ng-click="sortByValueOrder = false; sortBy = 'unMtchValue'; onMatchSongsRefresh();">  <i className="icon-sort-down text-xl pull-right"></i></span>

                                            </div>
                                        </th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filteredUnmatchedData?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td><input type="radio" onClick={() => selectRadioCatalog(values)} /></td>
                                                    <td >{values?.repItemCodeSold}</td>
                                                    <td >{values?.albumTitle}</td>
                                                    <td >{values?.albumArtist}</td>
                                                    <td >{values?.trackTitle}</td>
                                                    <td >{values?.trackArtist}</td>
                                                    <td >{values?.repAlbumCode1}</td>
                                                    <td >{values?.repAlbumCode2}</td>
                                                    <td >{values?.repTrackCode1}</td>
                                                    <td >{values?.repTrackCode2}</td>
                                                    <td >{values?.subFormat}</td>
                                                    <td >{values?.itemCodeSold}</td>
                                                    <td >{values?.unMtchValue}</td>

                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>}

                        </div>

                        <div className="ws-12 mb mtl">
                            {UnmatchedCount > 0 && <button className="pull-right btn icon-btn edit btn-xs" >  <i className="icon-download1"></i> </button>}
                            {UnmatchedCount > 0 && <button className="btn icon-btn edit btn-sm pull-right" title="Export Unmatched Songs" onClick={matchingSongsExport}>  <i className="icon-download1"></i> </button>}
                            {UnmatchedCount != 0 && accountCode.length != 0 && <button className="icon-btn delete btn-sm pull-right hide" onClick={onMatchSongsRefresh}> <i className="icon-reload"></i> Refresh  </button>}
                        </div>

                    </div>

                </div>

                <div className="ws-12 box mbl borderRounded pm">
                    <div className="ws-12 mtl ">
                        <div className="ws-9">
                            <input type="text" value={trackTitle} onChange={(e: any) => setTrackTitle(e.target.value)} className="w-23 mr" placeholder="Track(s)/Song(s) title" />

                            <input type="text" value={trackArtist} onChange={(e: any) => setTrackArtist(e.target.value)} className="w-23 mr" placeholder="Track(s)/Song(s) artist" />

                            <input type="text" value={isrcOrCatNum} onChange={(e: any) => setRsrcOrCatNum(e.target.value)} className="w-23 mr" placeholder="ISRC / Song / Song" />

                            <input type="text" value={repItemCodeSold} onChange={(e: any) => setRepItemCodeSoldrackTitle(e.target.value)} className="w-23 mr" placeholder="Contract / Class List" />
                        </div>

                        <div className="ws-3 pull-right pll">
                            <button className="btn btn-small  icon-btn delete" onClick={setSearchCat} title="Clear search form"><i className="icon-refresh"></i>  </button>
                            <button className="btn icon-btn edit btn-small " onClick={loadSystemSongs}><i className="icon-search"></i> Search </button>
                        </div>

                    </div>

                    {searchError && <div className="alert alert-danger mt">Fill in at least one search criteria to proceed.</div>}

                    <ul className="nav nav-tabs nav-justified p0 mt ws-12" data-ng-show="showSystemLists">
                        <a className={tab_number == "Releases" ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => tab_change("Releases")} >Releases</a>
                        <a className={tab_number == "Track_Song" ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => tab_change("Track_Song")} >Track(s) / Song(s)</a>
                        <a className={tab_number == "Contract" ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => tab_change("Contract")} >Contract</a>
                        <a className={tab_number == "Class_List" ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => tab_change("Class_List")} >Class List</a>
                    </ul>

                    <div className="slide ws-12">
                        {MatchingSongCount > 0 && <div className="clearfix mt ws-12 mbl">
                            <div className="form-format">
                                <label >Filter</label>
                                <div className="label-entries">
                                    <input type="text" className="form-control input-sm ws-8" placeholder="Search" value={filterFormats} onChange={(e: any) => filter_Formats(e.target.value)} id="formats" />
                                </div>
                            </div>
                        </div>}

                        {MatchingSongCount > 0 && <h4 className="mt ml"> {MatchingSongCount} record(s) found  </h4>}
                        {MatchingSongCount == 0 && <div className="alert alert-info mt ">No releases found</div>}
                        {MatchingSongCount > 0 && <table className="table">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {
                                        TransactionServices.MatchingSong_TableConfig?.find((tabValue: any) => tabValue.tableType === tab_number)
                                            ?.tableHeader?.map((header: string, index: number) => (
                                                <th key={index} className="forceSingleLine">{header}</th>
                                            ))
                                    }
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    MatchingSongSearch?.map((value: any) => {
                                        return (
                                            <tr>
                                                <td><input type="radio" onClick={() => { Select_MatchingAsset(value) }} /></td>
                                                {
                                                    TransactionServices.MatchingSong_TableConfig?.find((tabValue: any) => tabValue.tableType === tab_number)
                                                        ?.tableFields?.map((header: string, index: number) => (
                                                            <td key={index} className="forceSingleLine">{value[header]}</td>
                                                        ))
                                                }

                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>}

                        <div className="clearfix">

                            {MatchingSongCount > 0 && MatchingSongCount > 10 && <Pagination onPageChange={MatchingSong_PaginationChange} totalRow={MatchingSongCount} />}

                        </div>
                    </div>

                    {false && <div className="alert alert-danger mt" data-ng-show="repItemCodeSoldEmpty">  Rep Item Code Sold is Empty  </div>}
                    {false && <div className="alert alert-info">  The Rep Item Code Sol has already been aliased  </div>}
                    {false && <div className="alert alert-danger" data-ng-show="saveError">  You need to select at least one Song and one system Song to match  </div>}
                    {false && <div className="alert alert-info">Rep Item Code Sold or ISRC contain unwanted characters. Please choose another one.</div>}
                    {false && <div className="alert alert-success" data-ng-show="saveSuccess"> Songs have been matched successfully</div>}

                    <div className="ws-12 pm">
                        <div className="pull-right">
                            <button className="btn icon-btn edit btn-sm ml " onClick={saveSongsLink}> <i className="icon-save-disk"></i>Save Link  </button>
                        </div>

                        <div className="form-format pull-left mt ws-9">
                            <label ><input type="checkbox" checked={isGen} onChange={() => setisGen(!isGen)} />Create a general Alias  </label>
                        </div>
                    </div>

                </div>

                <div className="ws-12 box mbl borderRounded">
                    <h2 className="mt ml">  Existing Songs Aliases -{matchingSongViewAllCount} record(s) found  </h2>

                    <div className="form-format mb pm">
                        <label className="control-label ">Search</label>
                        <div className="ws-12">

                            <div className="ws-7">
                                <div className="ws-9">
                                    <input type="text" className="ws-12" placeholder="Enter exact Rep Item Code Sold / Reported Code" value={Search_field} onChange={(e: any) => setSearch_field(e.target.value)} id="catLogue" />
                                </div>

                                <button className="btn icon-btn edit" title="Search" onClick={() => matchingCalatog(Search_field, "Search")}>
                                    <i className="icon-search"></i> Search
                                </button>
                            </div>

                            <div className="ws-5 pull-right">

                                <button className="btn icon-btn edit ml pull-right" title="View all aliases" onClick={() => matchingCalatog("", "View All aliase")}>
                                    <i className="icon-search"></i> View All aliases
                                </button>

                                <button className="btn icon-btn edit ml pull-right" title="View all Account Code" onClick={() => matchingCalatog("", "View All")}>
                                    <i className="icon-search"></i> View All
                                </button>
                            </div>
                        </div>
                    </div>

                    {matchingSongViewAllCount == 0 && accountCode.length > 0 && <div className="alert alert-info"> No existing Songs aliases found for the selected account code or matching your search criteria </div>}
                    {false && <div className="alert alert-info" data-ng-show="deleteSuccess"> Alias deleted successfully </div>}

                    <div className="pm ws-12">
                        {matchingSongViewAllCount > 0 && <table className="newTable">
                            <thead>
                                <tr>
                                    <th className="forceSingleLine">Reported code</th>
                                    <th className="forceSingleLine">Matched code</th>
                                    <th className="forceSingleLine">Account Code</th>
                                    <th className="forceSingleLine">ISRC</th>
                                    <th className="forceSingleLine">Song</th>
                                    <th className="forceSingleLine">Album title</th>
                                    <th className="forceSingleLine">Album artist</th>
                                    <th className="forceSingleLine">Track title</th>
                                    <th className="forceSingleLine">Track artist</th>
                                    <th className="forceSingleLine">Operation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {matchingSongViewAll?.map((values: any) => {
                                    return (
                                        <tr>
                                            <td>{values.theirCode}</td>
                                            <td>{values.ourCode}</td>
                                            <td>{values.accountCode}</td>
                                            <td>{values.iSrC}</td>
                                            <td>{values.ourCode}</td>
                                            <td>{values.albumTitle}</td>
                                            <td>{values.albumArtist}</td>
                                            <td>{values.trackTitle}</td>
                                            <td>{values.trackArtist}</td>
                                            <td>
                                                <a title="Delete" onClick={() => deleteCAlias(values)} className="icon-btn delete">
                                                    <i className="icon-trashcan"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>}
                    </div>

                    <div className="clearfix mt">
                        {(() => {
                            if (matchingSongViewAllCount && matchingSongViewAllCount > 10) {
                                return <Pagination onPageChange={matchingSongViewAllPagination} totalRow={matchingSongViewAllCount} />
                            }
                        })()}
                    </div>
                </div>

                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={true} message={"delete this alias"} onChange={Confirmation} />
                        }
                    })()
                }

            </div>

        </>
    )
}